import './App.css';
import ActivityList from './Component/ActivityList/ActivityList';

import Header from './Component/Header/Header';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <ActivityList></ActivityList>
    </div>
  );
}

export default App;
